// import React, { useState, useEffect } from 'react';
// import Box from '@/Atoms/Box';
// import CCText from '@/Atoms/CCText';
// import CCColors from '@/Utils/CCColors';
// import { FontSizes, vs } from '@/Utils/Dimensions';
// import CCPackageTable from '@/Atoms/CCPackageTable';
// import useGetTournamentPairings from '@/Hooks/TournamentsApi/useGetTournamentPairings';
// import RoundNavigator from './RoundNavigator';

// const Games: React.FC <{ round: number; tournamentId: string; setGameId: (gameId : string) => void; setActiveTab: (active_tab: string) => void; playing : boolean;  }> = ({ round, tournamentId, setGameId, setActiveTab, playing }) =>  {
//   // Mock data for games

//   const [currentRound, setCurrentRound] = useState(round);
//   const {
//     mutate: fetchTournamentPairings,
//     data: tournamentPairings,
//     isLoading,
//     isError,
//     error,
//   } = useGetTournamentPairings();

//   // Fetch the tournament details when the component mounts
//   useEffect(() => {
//     if (tournamentId) {
//       fetchTournamentPairings({round:currentRound,tournamentId});
//     }
//   }, [currentRound]);

//   console.log("pairings:", tournamentPairings?.data);

//   const gamesData = tournamentPairings?.data?.map(({ player, opponent }) => ({
//     white: player.player_name, // Player is whiteset
//     black: opponent.player_name, // Opponent is black
//     result: player.result || "ongoing",
//     gameId: player.cc_gameid
//   })) || [
//     { white: '', result: '', black: '', gameId: '' },
//   ];

//   const headers = ['White', 'Result', 'Black'];

//   // Transform gamesData into tableData format
//   const tableData = gamesData?.map((game) => {
//     const white = game.white;
//     const result = game.result;
//     const black = game.black;

//     let itemValues: any = [];

//     itemValues.push({
//       name: (
//         <Box style={{ padding: vs(10), width: '100%', height: '100%' }}>
//           <CCText fontSize={FontSizes[12]}>{white}</CCText>
//         </Box>
//       ),
//       type: 'text',
//     });

//     itemValues.push({
//       name: (
//         <Box style={{ padding: vs(10), width: '100%', height: '100%' }}>
//           <CCText fontSize={FontSizes[12]} color={CCColors.Blue}>
//             {result}
//           </CCText>
//         </Box>
//       ),
//       type: 'text',
//     });

//     itemValues.push({
//       name: (
//         <Box style={{ padding: vs(10), width: '100%', height: '100%' }}>
//           <CCText fontSize={FontSizes[12]}>{black}</CCText>
//         </Box>
//       ),
//       type: 'text',
//     });

//     return itemValues;
//   });

//   // Style adjustments for games rows
//   const customFlexArr = [3, 1, 3];

//   // Handle row press (e.g., navigate to game details)
//   const handleRowPress = (rowIndex: number) => {
//     console.log(`Row ${rowIndex} pressed`);
//     if(!playing){
//       const gameId = gamesData[rowIndex].gameId;
//       setGameId(gameId);
//       setActiveTab('notation');
//     }

//     // Example: navigation.navigate('GameDetails', { id: rowIndex });
//   };

//   return (
//     <Box>
//       {/* <CCText
//         textAlign="center"
//         fontSize={FontSizes[14]}
//         fontWeight="bold"
//         style={{ marginBottom: vs(10) }}>
//         Games for round {round}
//       </CCText> */}
//       <RoundNavigator
//         totalRounds={round}
//         currentRound={currentRound}
//         setRound={setCurrentRound}
//       />
//       <CCPackageTable
//         headers={headers}
//         tableData={tableData}
//         flexArr={customFlexArr}
//         handleRowPress={handleRowPress}
//         borderBottomColor={CCColors.BorderBottom}
//         jsxTable={true} // Enables Pressable rows
//       />
//     </Box>
//   );
// };

// export default Games;

import React, {useState, useEffect, useMemo, useRef} from 'react';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {FontSizes, vs, WINDOW_HEIGHT, WINDOW_WIDTH} from '@/Utils/Dimensions';
import CCPackageTable from '@/Atoms/CCPackageTable';
import useGetTournamentPairings from '@/Hooks/TournamentsApi/useGetTournamentPairings';
import RoundNavigator from './RoundNavigator';
import {Platform, Switch, View, ScrollView} from 'react-native';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import {Image} from 'react-native';
import NoPairings from '@/Assets/Images/Tournaments/no_pairing.svg';
import {RFPercentage} from 'react-native-responsive-fontsize';
import {debounce, getColorFromUsername} from '@/Utils/CommonUtils';
import CCButton from '@/Atoms/CCButton';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Pagination from '@/Screens/Games/Pagination';
import SlideModal from '@/Atoms/SlideModal';

const Games: React.FC<{
  round: number;
  tournamentId: string;
  setGameId: (gameId: string) => void;
  setActiveTab: (active_tab: string) => void;
  playing: boolean;
  isMobileOrTab: boolean;
  watchTournamentGame: (
    pairingKey: string,
    tournamentId: string,
    round: number,
  ) => void;
  showOngoingTab?: boolean;
  gamesEnded: number;
  isConnected: boolean;
  isOngoing: boolean;
  setIsOngoing: (isOngoing: boolean) => void;
  searchterm: string;
  username: string;
  userId: string | null;
  refreshApi: boolean;
  setPlayerUserId: (id: string | null) => void;
  setRefreshApi: (refreshApi: boolean) => void;
  activeTab: string;
}> = ({
  round,
  tournamentId,
  setGameId,
  setActiveTab,
  playing = false,
  isMobileOrTab,
  watchTournamentGame,
  gamesEnded,
  showOngoingTab,
  isConnected,
  isOngoing,
  setIsOngoing,
  searchterm,
  username,
  userId,
  refreshApi,
  setPlayerUserId,
  setRefreshApi,
  activeTab,
}) => {
  const tableRef = useRef(null);
  const [currentRound, setCurrentRound] = useState(round);
  const [currentPage, setCurrentPage] = useState(1);
  const [showByePopup, setShowByePopup] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [shouldCallMainApi, setShouldCallMainApi] = useState(true);
  const {
    mutate: fetchTournamentPairings,
    data: tournamentPairings,
    isLoading,
    isError,
    error,
  } = useGetTournamentPairings();

  const limit = 10;
  const offset = (currentPage - 1) * limit;

  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearchTerm(searchterm);
    }, 500);

    handler();
  }, [searchterm]);

  useEffect(() => {
    if (refreshApi && activeTab === 'games') {
      const payload: any = {
        round: currentRound,
        tournamentId,
        limit,
        offset: 0,
      };

      fetchTournamentPairings(payload, {
        onSuccess: () => {
          setCurrentPage(1);
          setRefreshApi(false);
        },
      });
    }
  }, [refreshApi, activeTab]);

  useEffect(() => {
    if (tournamentId && shouldCallMainApi) {
      fetchTournamentPairings({
        round: currentRound,
        tournamentId,
        limit: limit,
        offset: debouncedSearchTerm ? 0 : offset,
        // ...(debouncedSearchTerm ? {search: debouncedSearchTerm} : {}),
        ongoing: isOngoing,
      });
      setShouldCallMainApi(false);
    }
  }, [
    currentRound,
    tournamentId,
    // Live refetch trigger — PlayChess bumps `gamesEnded` (throttled) when
    // tournament_game_end_response / pairing broadcasts arrive. Without this
    // dep the broadcasts get delivered to the client but the pairings table
    // never refetches, so users see stale results until they navigate away
    // and back.
    gamesEnded,
    isConnected,
    currentPage,
    isOngoing,
    // debouncedSearchTerm,
  ]);

  useEffect(() => {
    setCurrentRound(round);
  }, [round]);

  useEffect(() => {
    if (tournamentPairings?.data?.length > 0 && username) {
      const gotBye = tournamentPairings.data.some(item => {
        const playerId = item?.player?.cc_userid;
        const opponentId = item?.opponent?.cc_userid;

        const isUserInPlayer = String(playerId) === String(username);
        const isUserInOpponent = String(opponentId) === String(username);

        console.log('playerId, opponentId: ', playerId, opponentId, username);

        return (
          (isUserInPlayer && !item?.opponent) ||
          (isUserInOpponent && !item?.player)
        );
      });

      if (gotBye) {
        setShowByePopup(true);
      }
    }
  }, [tournamentPairings, username]);

  const gamesData =
    tournamentPairings?.data?.map((data, originalIndex) => {
      const white = data?.player?.player_name || 'BYE';
      const black = data?.opponent?.player_name || 'BYE';
      const whiteRating = data?.player?.player_rating || '';
      const blackRating = data?.opponent?.player_rating || '';
      let result = data?.player?.result || '-'; // Default result
      const pairingKey = `pairing:${data?.player?.cc_userid}-${data?.opponent?.cc_userid}`;

      // Handle cases where one player is missing
      if (!data?.player) {
        result = '0-1'; // Black wins if White is missing
      } else if (!data?.opponent) {
        result = '1-0'; // White wins if Black is missing
      }

      const playerUpdated = data?.player?.updatedAt
        ? getRelativeTime(data?.player.updatedAt)
        : '-';
      const opponentUpdated = data?.opponent?.updatedAt
        ? getRelativeTime(data?.opponent.updatedAt)
        : '-';

      const white_title = data?.player?.player_title || '';
      const black_black = data?.opponent?.ccm_tournament_player?.title || '';

      return {
        white,
        white_rating: whiteRating,
        black,
        black_rating: blackRating,
        result,
        gameId: data?.player?.cc_gameid || null, // If player is missing, gameId is null
        tableId: data?.player?.table_id || 0,
        pairingKey,
        playerUpdated,
        opponentUpdated,
        white_title,
        black_black,
        round: data?.player?.round,
        createdAt: data?.player?.createdAt,
        originalIndex,
      };
    }) || [];

  const headers = ['Board No.', 'Players', 'Last Move', 'Status'];
  const mobileHeaders = ['Players', 'Result'];
  // The server already returns ongoing-only rows when ongoing=true; a second
  // client-side filter here desynced page size from board numbers / totalPages.
  let filteredGamesData = gamesData;

  // Filter by search term (if any)
  if (searchterm && searchterm?.trim() !== '') {
    const lowerSearch = searchterm?.toLowerCase();
    filteredGamesData = filteredGamesData?.filter(
      game =>
        game?.white?.toLowerCase()?.includes(lowerSearch) ||
        game?.black?.toLowerCase()?.includes(lowerSearch),
    );
  }
  function getRelativeTime(dateString) {
    if (!dateString) {
      return '-';
    }
    const now = new Date().getTime();
    const date = new Date(dateString).getTime();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    if (diffSec < 60) {
      return `${diffSec}s ago`;
    }
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) {
      return `${diffMin}m ago`;
    }
    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) {
      return `${diffHr}h ago`;
    }
    const diffDay = Math.floor(diffHr / 24);
    return `${diffDay}d ago`;
  }

  const tableData = filteredGamesData?.map((game, index) => {
    let lastMoveTime = '-';
    if (game?.playerUpdated && game?.opponentUpdated) {
      lastMoveTime =
        new Date(game?.playerUpdated) > new Date(game?.opponentUpdated)
          ? game?.playerUpdated
          : game?.opponentUpdated;
    } else if (game?.playerUpdated) {
      lastMoveTime = game?.playerUpdated;
    } else if (game?.opponentUpdated) {
      lastMoveTime = game?.opponentUpdated;
    }

    return [
      {
        name: (
          <Box style={{padding: vs(10)}}>
            <CCText
              fontSize={FontSizes[10]}
              style={{
                color: CCColors?.TextColor?.Primary,
                fontWeight: '600',
              }}>
              {offset + game?.originalIndex + 1}.
            </CCText>
          </Box>
        ),
        type: 'text',
      },
      {
        name: (
          <Box style={{padding: vs(10), width: '100%'}}>
            <Box style={{flexDirection: 'row', alignItems: 'center'}}>
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 16,
                  backgroundColor: CCColors?.LightBrownShade,
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: 10,
                }}>
                <CCText
                  fontSize={FontSizes[10]}
                  style={{color: CCColors?.BrownShade2, fontWeight: '600'}}>
                  {game?.white?.substring(0, 2)?.toUpperCase() || ''}
                </CCText>
              </View>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 6,
                }}>
                <CCText fontSize={FontSizes[12]}>
                  {game?.white_title && (
                    <CCText
                      fontWeight="bold"
                      color={CCColors?.Red}
                      style={{marginRight: 4}}>
                      {game?.white_title}
                    </CCText>
                  )}{' '}
                  {game?.white}
                </CCText>
                <CCText fontSize={FontSizes[10]} color="#888">
                  {game?.white_rating}
                </CCText>
              </Box>
            </Box>
            <Box
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: vs(6),
              }}>
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 16,
                  backgroundColor: CCColors?.LightBrownShade,
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: 10,
                }}>
                <CCText
                  fontSize={FontSizes[10]}
                  style={{color: CCColors?.BrownShade2, fontWeight: '600'}}>
                  {game?.black?.substring(0, 2)?.toUpperCase() || ''}
                </CCText>
              </View>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 6,
                }}>
                <CCText fontSize={FontSizes[12]}>
                  {game?.black_title && (
                    <CCText
                      fontWeight="bold"
                      color={CCColors?.Red}
                      style={{marginRight: 4}}>
                      {game?.black_title}
                    </CCText>
                  )}
                  {game?.black}
                </CCText>
                <CCText fontSize={FontSizes[10]} color="#888">
                  {game?.black_rating}
                </CCText>
              </Box>
            </Box>
          </Box>
        ),
        type: 'text',
      },
      {
        name:
          game?.result === '-' ? (
            <CCButton
              contentContainerStyle={{
                paddingHorizontal: 10,
              }}
              onPress={() => handleRowPress(index)}>
              <MaterialCommunityIcons name="eye-outline" size={20} />
            </CCButton>
          ) : (
            <Box
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}>
              <CCText fontSize={FontSizes[12]}>{lastMoveTime}</CCText>
            </Box>
          ),
        type: 'text',
      },
      {
        name: (
          <Box
            style={{
              paddingHorizontal: vs(10),
              paddingVertical: vs(6),
              backgroundColor: '#FAF6EB',
              borderRadius: 10,
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'center',
            }}>
            <CCText fontSize={FontSizes[12]}>{game?.result}</CCText>
          </Box>
        ),
        type: 'text',
      },
      // {
      //   name: (
      //     <Box
      //       style={{
      //         padding: vs(10),
      //         width: '100%',
      //         height: '100%',
      //         alignItems: 'center',
      //       }}>
      //       <CCText fontSize={FontSizes[12]}>
      //         {game.black}
      //         {`(${game.black_rating})`}
      //       </CCText>
      //     </Box>
      //   ),
      //   type: 'text',
      // },
    ];
  });

  const mobileTableData = filteredGamesData.map(game => [
    {
      name: (
        <Box
          style={{
            padding: vs(10),
            width: '90%',
            height: '100%',
            alignItems: 'flex-start',
          }}>
          <Box style={{alignItems: 'flex-start', width: 'auto'}}>
            <CCText
              color={CCColors.Primary.Brown}
              fontWeight={500}
              fontSize={!isMobileOrTab ? FontSizes[14] : RFPercentage(2)}
              style={{}}>
              {game.white}
            </CCText>
            <CCText
              fontWeight={500}
              color={CCColors.TextColor.GreyText}
              fontSize={!isMobileOrTab ? FontSizes[12] : RFPercentage(1.8)}
              style={{}}>
              {game.white_rating}
            </CCText>
          </Box>
          <Box style={{alignItems: 'flex-start', width: 'auto'}}>
            <CCText
              color={CCColors.Primary.Brown}
              fontWeight={500}
              fontSize={!isMobileOrTab ? FontSizes[14] : RFPercentage(2)}
              style={{}}>
              {game.black}
            </CCText>
            <CCText
              fontWeight={500}
              color={CCColors.TextColor.GreyText}
              fontSize={!isMobileOrTab ? FontSizes[12] : RFPercentage(1.8)}
              style={{}}>
              {game.black_rating}
            </CCText>
          </Box>
        </Box>
      ),
      type: 'text',
    },
    {
      name: (
        <Box
          flexDirection="column"
          gap={20}
          style={{
            padding: vs(10),
            width: '100%',
            height: '100%',
            alignItems: game.result === '-' ? 'center' : 'flex-start',
          }}>
          {game.result === '-' ? (
            <Box
              style={{
                width: '100%',
                height: '50%',
                justifyContent: !isMobileOrTab ? 'flex-start' : 'center',
                alignItems: !isMobileOrTab ? 'flex-start' : 'center',
                marginRight: 10,
              }}>
              <Image
                style={{
                  width: 80,
                  height: 20,
                }}
                source={require('@/Assets/Images/Svgs/IsOngoing.svg')}
              />
            </Box>
          ) : (
            <>
              <Box style={{justifyContent: 'flex-start'}}>
                <CCText
                  color={
                    game.result.split('-')[0] == 0
                      ? CCColors.Red
                      : game.result.split('-')[0] == 0.5
                      ? CCColors.EvaluationScore.Background
                      : CCColors.Green
                  }
                  fontSize={!isMobileOrTab ? FontSizes[14] : RFPercentage(2)}
                  fontWeight={500}>
                  {game.result.split('-')[0]}
                </CCText>
              </Box>
              <Box>
                <CCText
                  color={
                    game.result.split('-')[1] == 0
                      ? CCColors.Red
                      : game.result.split('-')[1] == 0.5
                      ? CCColors.EvaluationScore.Background
                      : CCColors.Green
                  }
                  fontWeight={500}
                  fontSize={!isMobileOrTab ? FontSizes[14] : RFPercentage(2)}>
                  {game.result.split('-')[1]}
                </CCText>
              </Box>
            </>
          )}
        </Box>
      ),
      type: 'text',
    },
  ]);
  const mobileFlexArr = [0.6, 4, 1];

  const handleRowPress = (rowIndex: number) => {
    // console.log('row pressed in pairings', filteredGamesData[rowIndex]);
    if (!playing) {
      const gameId = filteredGamesData?.[rowIndex]?.gameId;
      const pairingKey = filteredGamesData?.[rowIndex]?.pairingKey;
      const createdAt = filteredGamesData?.[rowIndex]?.createdAt
        ? new Date(filteredGamesData[rowIndex].createdAt)
        : null;

      const fiveDaysPassed =
        createdAt && Date.now() - createdAt.getTime() > 5 * 24 * 60 * 60 * 1000;

      if (gameId && fiveDaysPassed) {
        setGameId(gameId);
        setActiveTab('notation');
      } else if (pairingKey && filteredGamesData?.[rowIndex]?.black !== 'BYE') {
        console.info(
          'watch tableId: ',
          pairingKey,
          filteredGamesData?.[rowIndex],
        );
        watchTournamentGame(
          pairingKey,
          tournamentId,
          filteredGamesData?.[rowIndex]?.round,
        );
        // setActiveTab('notation');
      }
    }
  };

  const totalCount = tournamentPairings?.count || 0;
  const totalPages = Math.ceil(totalCount / 10);

  const highlightedRowIndex = tournamentPairings?.data
    ?.map((item, i) => {
      const playerId = String(item?.player?.cc_userid ?? '');
      const opponentId = String(item?.opponent?.cc_userid ?? '');
      const uname = String(username ?? '');

      const matched = playerId === uname || opponentId === uname;
      return matched ? i : '';
    })
    .filter(String);

  const scrollToPlayer = () => {
    const height = highlightedRowIndex * 80;
    tableRef?.current?.scrollTo({y: height, animated: true});
  };

  useEffect(() => {
    if (userId) {
      const payload: any = {
        round: currentRound,
        tournamentId,
        limit,
        offset,
        // ...(debouncedSearchTerm ? {search: debouncedSearchTerm} : {}),
        ongoing: isOngoing,
        userId,
      };

      // setPlayerUserId(null);
      if (
        Array.isArray(highlightedRowIndex) &&
        highlightedRowIndex.length > 0
      ) {
        scrollToPlayer();
      } else {
        fetchTournamentPairings(payload, {
          onSuccess: (data: any) => {
            if (data?.currentPage) {
              setCurrentPage(data?.currentPage);
            }
          },
        });
      }
    }
  }, [userId]);

  useEffect(() => {
    scrollToPlayer();
  }, [highlightedRowIndex]);

  return (
    <Box style={{height: WINDOW_HEIGHT / 1.85}}>
      <Box
        style={{
          flexDirection: 'row',
          justifyContent: showOngoingTab ? 'space-between' : 'flex-start',
          alignItems: 'center',
          // marginBottom: vs(10),
          marginLeft: vs(8),
          width: isMobileOrTab ? '100%' : '50%',
        }}>
        <RoundNavigator
          totalRounds={round}
          currentRound={currentRound}
          setRound={(newRound: number) => {
            setCurrentRound(newRound);
            setPlayerUserId(null);
            setShouldCallMainApi(true);
          }}
          setIsOngoing={setIsOngoing}
          setCurrentPage={setCurrentPage}
        />
        {showOngoingTab && round === currentRound && (
          <Box
            style={{
              backgroundColor: '#FAF6EB',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              shadowColor: '#000',
              shadowOffset: {width: 0, height: 2},
              shadowOpacity: 0.2,
              shadowRadius: 3,
              elevation: 3,
              height: '75%',
              width: !isMobileOrTab && '50%',
              borderRadius: 8,
            }}>
            <CCText
              style={{
                fontSize: 16,
                marginRight: 10,
                alignSelf: 'center',
                margin: 8,
              }}>
              Ongoing
            </CCText>
            <Switch
              trackColor={{false: '#767577', true: CCColors.Green}}
              thumbColor={isOngoing ? '#f5dd4b' : '#f4f3f4'}
              ios_backgroundColor="#3e3e3e"
              onValueChange={() => {
                setIsOngoing(!isOngoing);
                setPlayerUserId(null);
                // Toggling Ongoing must refetch from page 1 — the server,
                // not the client, decides which rows are ongoing.
                setCurrentPage(1);
                setShouldCallMainApi(true);
              }}
              value={isOngoing}
              style={{
                marginRight: 8,
              }}
            />
          </Box>
        )}
      </Box>
      <ScrollView ref={tableRef}>
        {tableData?.length > 0 ? (
          <>
            <CCPackageTable
              headers={headers}
              tableData={tableData}
              flexArr={mobileFlexArr}
              handleRowPress={handleRowPress}
              borderBottomColor={updateColorWithOpacity(
                CCColors?.Grey.Grey,
                0.3,
              )}
              jsxTable={true}
              // headerStyle={{alignSelf : 'center'}}
              // margin = {0}
              headerTextColor={CCColors.TextColor.Grey}
              isMargin={false} // Enables Pressable rows
              tournament={true}
              backgroundColorRow={true}
              headerHeight={50}
              tableBorder={false}
              border={true}
              higlightedRow={highlightedRowIndex}
              // jsxTable
            />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              paginate={(page: number) => {
                setCurrentPage(page);
                setPlayerUserId(null);
                setShouldCallMainApi(true);
              }}
              maxPage={5}
            />
          </>
        ) : (
          <View
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              padding: 20,
              gap: 10,
              marginTop: isMobileOrTab ? 0 : '5%',
            }}>
            <Image
              resizeMode="contain"
              style={{
                width: !isMobileOrTab ? 160 : 100,
                height: !isMobileOrTab ? 160 : 100,
              }}
              source={NoPairings}
            />
            <CCText
              fontSize={FontSizes[20]}
              style={{lineHeight: 20, fontWeight: 500}}>
              No pairing found
            </CCText>
            <CCText
              fontSize={FontSizes[16]}
              color={CCColors?.TextColor?.Dark}
              style={{fontWeight: 400}}>
              Pairing will appear here after sometime.
            </CCText>
          </View>
        )}
      </ScrollView>
      {false && (
        <SlideModal
          type="center"
          visible={showByePopup}
          onClose={() => setShowByePopup(false)}
          minWidth={WINDOW_WIDTH / 12}>
          <Box
            style={{
              padding: 20,
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Image
              source={require('@/Assets/Images/png/win_result.png')}
              style={{width: 120, height: 120, marginBottom: 20}}
              resizeMode="contain"
            />
            <CCText
              fontSize={FontSizes[18]}
              fontWeight="bold"
              textAlign="center">
              Congratulations! You won the match!
            </CCText>
            <CCText
              fontSize={FontSizes[14]}
              color={CCColors.TextColor.Dark}
              numberOfLines={2}
              style={{marginTop: 10, textAlign: 'center'}}>
              No opponent assigned, you received a bye in this round. Please
              wait for the next round!
            </CCText>
            <CCButton
              style={{marginTop: 20}}
              onPress={() => setShowByePopup(false)}>
              Okay
            </CCButton>
          </Box>
        </SlideModal>
      )}
    </Box>
  );
};

export default Games;
